export const EDITOR_MANAGING_STAFF_OPTIONS = [
  "code",
  "generalName",
  "StandardCountIndicator",
  "StandardTrainingIndicator",
  "combineTraining",
  "StandardCertificationIndicator",
  "combineCertification",
];

export const EDITOR_MANAGING_STAFF_INDICATORS_PERIOD_OPTIONS = [
  "StandardCertificationIndicator",
  "StandardCountIndicator",
  "StandardTrainingIndicator",
];
